// extracted by mini-css-extract-plugin
export default {"container":"NM-z","title":"OM-z","link":"PM-z"};